const KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
let loadPromise = null;

// Google calls this global when the API key is rejected (bad key, referrer
// restriction, disabled billing/API). We flag it so inputs can degrade to plain text.
if (typeof window !== "undefined") {
  window.__gmapsAuthFailed = window.__gmapsAuthFailed || false;
  window.gm_authFailure = () => {
    window.__gmapsAuthFailed = true;
  };
}

export const gmapsAuthFailed = () =>
  typeof window !== "undefined" && !!window.__gmapsAuthFailed;

export const hasMapsKey = () => !!KEY;

export const loadGoogleMaps = () => {
  if (window.google?.maps?.places) return Promise.resolve(window.google);
  if (loadPromise) return loadPromise;
  loadPromise = new Promise((resolve, reject) => {
    if (!KEY) return reject(new Error("Google Maps key missing"));
    const s = document.createElement("script");
    s.src = `https://maps.googleapis.com/maps/api/js?key=${KEY}&libraries=places&v=weekly`;
    s.async = true;
    s.defer = true;
    s.onload = () => resolve(window.google);
    s.onerror = () => reject(new Error("Failed to load Google Maps"));
    document.head.appendChild(s);
  });
  return loadPromise;
};

export const staticMapUrl = (lat, lng, { zoom = 14, w = 640, h = 300, color = "0D9488" } = {}) =>
  lat == null || lng == null || !KEY
    ? null
    : `https://maps.googleapis.com/maps/api/staticmap?center=${lat},${lng}&zoom=${zoom}&size=${w}x${h}&scale=2&maptype=roadmap&markers=color:0x${color}%7C${lat},${lng}&key=${KEY}`;

export const streetViewUrl = (lat, lng, { w = 640, h = 300 } = {}) =>
  lat == null || lng == null || !KEY
    ? null
    : `https://maps.googleapis.com/maps/api/streetview?size=${w}x${h}&location=${lat},${lng}&fov=80&pitch=0&key=${KEY}`;
